var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"icon-content"},[_c('img',{staticClass:"icon-tip",attrs:{"src":_vm.appData.merJumpBackgroundUrl}}),_c('div',{staticClass:"click-content"},[_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }